import { useCallback } from 'react';

export const ConditionalFieldRenderer = ({
  fieldsObject,
  fieldType,
  children,
  fallback = null
}) => {
  const shouldRender = useCallback(() => {
    const hasField =
      fieldsObject?.[fieldType] &&
      Object.keys(fieldsObject[fieldType]).length > 0;
    if (!hasField) return false;

    const { new: newField } = fieldsObject[fieldType];
    return newField?.isActive;
  }, [fieldsObject, fieldType]);

  return shouldRender() ? children : fallback;
};
